import Axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios';

import { env as environment } from '../env/client';
import { useAuthStore } from '~/store';

export const AXIOS_INSTANCE = Axios.create({
  baseURL: environment.NEXT_PUBLIC_SWAGGER_URL,
});

export const customInstance = <T>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
  const source = Axios.CancelToken.source();

  let token: string | null = null;

  if (typeof window !== 'undefined') {
    token = useAuthStore.getState().accessToken;
  }

  const promise = AXIOS_INSTANCE({
    ...config,
    cancelToken: source.token,
    headers: {
      // eslint-disable-next-line @typescript-eslint/no-misused-spread
      ...config.headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return promise;
};
